/*!
 * Manera Adventures
 * 
 */
$(document).ready(function() {
    /*** POPUP ADVENTURE **/
    if ($('.adv-full-popup').length > 0)
    {
        $('.subnav_number a').on('click', function (e) {
            e.preventDefault();
            var parent = $(this).parent();
            var number = parent.data('number');

            TweenMax.to('.popup', 1, {scrollTo: "#popup_anchor_" + number});
        });

        var titles = $('.adv-full-popup').find('h3');
        var advController = new ScrollMagic.Controller();
        titles.each(function(index)
        {
           var title = $(this); //current title
           var id = title.prop('id');// title id
           var number = id.split('popup_anchor_'); //get number
           var title_txt = title.text(); //get title text
           var nav = $('[data-number="' + number[1] + '"]').parent();
           var nextTitle = $(titles[index + 1]);
           var distance = 0;

           if(nextTitle.length > 0)
               distance = nextTitle.offset().top - title.offset().top;

           var scene = new ScrollMagic.Scene({
               triggerElement: title,
               duration: distance
           }).addTo(advController);

           scene.on('start', function (e) {

               $('.subnav_sub').removeClass('active');
               nav.addClass('active');
               advPopupChangeTitle(title_txt);

               if(e.state == "BEFORE")
               {
                   if (index > 0) {
                       var prevTitle = titles[index-1];
                       var prevNumber = $(prevTitle).prop('id').split('popup_anchor_');
                       var prevNav = $('[data-number="' + prevNumber[1] + '"').parent();
                       var prevTitle_txt = $(prevTitle).text();
                       nav.removeClass('active');
                       prevNav.addClass('active');
                       advPopupChangeTitle(prevTitle_txt);
                   }
               }
           });

        });
        function advPopupChangeTitle(title)
        {
            $('.subnav_title').find('.text').text(title);
        }
    }

    $('.adv-riders a').on('mouseenter',function(e){
        e.preventDefault();
        var first = $('.adv-full-decoration1 .img1');
        var img = $(this).data('picture');
                first.css('backgroundImage','url('+img+')');
                first.find('img').prop('src',img);
    })

});